export enum CurrencyKeys {
  CODE = "code",
  NAME = "name",
  SYMBOL = "symbol",
  IS_ZERO_DECIMAL = "isZeroDecimal",
}

export enum CurrencyStateKeys {
  CURRENCIES = "currencies",
  LOADING = "loading",
  LOADED = "loaded",
}
